import { updateTeam } from "api/Settings";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useUpdateTeam = (isBroker: boolean) => {
    const queryClient = useQueryClient();
    return useMutation(updateTeam, {
        onSuccess: () => {
            queryClient.invalidateQueries('teams');
            queryClient.invalidateQueries(['widgetData',isBroker ? 'Data Sharing Brokers' : 'Data Sharing Teams']);

            toast.success("Updated Successfully");
        },
        onError: (error:any) => {
            if(error?.response?.data?.message) { 
                toast.error(error?.response?.data?.message);
                return;
            }
            if(error?.response?.data?.error) { 
                toast.error(error?.response?.data?.error);
                return;
            }
            toast.error(`Something went wrong`);
        },
    });
};
